import { Fragment } from "react";
import { withRoomNouns } from "./roomNouns";

/*
  `withRoomNouns`, but brand-safe: the brand is cut out first and passed through
  untouched. The splitter is case-sensitive, so "aSTRING" no longer holds a room
  noun ("aString" did); this stays so the brand can never be set as one.
*/
export function nouns(sentence: string) {
  return sentence.split(/(aSTRING)/g).map((part, i) =>
    part === "aSTRING" ? (
      <Fragment key={i}>{part}</Fragment>
    ) : (
      <Fragment key={i}>{withRoomNouns(part)}</Fragment>
    )
  );
}
